/**
 * 날짜 관련 유틸리티 함수
 */

/**
 * BSDA 형식 유효성 검사
 * @param {string} bsdaStr - BSDA 문자열
 * @returns {boolean} 유효한 형식인지 여부
 */
export const validateBsdaFormat = (bsdaStr) => {
  const trimmed = bsdaStr.trim();
  if (trimmed.length === 8 || trimmed.length === 14) {
    return /^\d+$/.test(trimmed);
  }
  return false;
};

/**
 * 쉼표로 구분된 BSDA 문자열을 파싱
 * @param {string} bsdaStr - 쉼표로 구분된 BSDA 문자열
 * @returns {string[]} 유효한 BSDA 날짜 배열
 */
export const parseBsdaDates = (bsdaStr) => {
  return bsdaStr
    .split(',')
    .map(d => d.trim())
    .filter(d => d.length > 0 && validateBsdaFormat(d));
};

/**
 * BSDA 날짜를 읽기 쉬운 형식으로 변환
 * @param {string} bsda - BSDA 날짜 (YYYYMMDD 형식)
 * @returns {string} YYYY-MM-DD 형식
 */
export const formatBsdaDate = (bsda) => {
  if (bsda.length >= 8) {
    return `${bsda.slice(0, 4)}-${bsda.slice(4, 6)}-${bsda.slice(6, 8)}`;
  }
  return bsda;
};

/**
 * YYYY-MM-DD 형식을 YYYYMMDD로 변환
 * @param {string} dateStr - YYYY-MM-DD 형식 날짜
 * @returns {string} YYYYMMDD 형식
 */
export const dateToBasda = (dateStr) => {
  return dateStr.replace(/-/g, '');
};

/**
 * 날짜 범위 내의 모든 날짜를 BSDA 형식 배열로 반환
 * @param {string} startDate - 시작일 (YYYY-MM-DD)
 * @param {string} endDate - 종료일 (YYYY-MM-DD)
 * @returns {string[]} BSDA 형식 날짜 배열
 */
export const getDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dates = [];

  if (start > end) {
    return dates;
  }

  let currentDate = new Date(start);
  while (currentDate <= end) {
    const formatted = currentDate.toISOString().slice(0, 10).replace(/-/g, '');
    dates.push(formatted);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

/**
 * 날짜 범위의 일수 계산
 * @param {string} startDate - 시작일 (YYYY-MM-DD)
 * @param {string} endDate - 종료일 (YYYY-MM-DD)
 * @returns {number} 일수
 */
export const getDayCount = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (start > end) {
    return 0;
  }

  return Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
};
